import { useEffect, useReducer } from 'react';

const MAX_TIMEOUT_MS = 2 ** 31 - 1; // setTimeout fires immediately for longer delays, so wait in chunks

/**
 * Returns whether `time` (epoch ms) has arrived, re-rendering at that moment so the answer flips on an open page.
 */
export default function useHasTimeArrived(time: number | null): boolean {
    const [waits, rerender] = useReducer((count: number) => count + 1, 0);
    const hasArrived = time !== null && Date.now() >= time;

    useEffect(() => {
        if (time === null || hasArrived) {
            return undefined;
        }
        const timeoutId = setTimeout(rerender, Math.min(time - Date.now(), MAX_TIMEOUT_MS));
        return () => clearTimeout(timeoutId);
    }, [time, hasArrived, waits]);

    return hasArrived;
}
